import { Link } from '@tanstack/react-router';

interface CustomerLinkProps {
  customerId: string;
  customerName: string | null;
}

export function CustomerLink({ customerId, customerName }: CustomerLinkProps) {
  return (
    <Link
      to="/accounts-receivable/collections/$customerId"
      params={{ customerId }}
      className="text-sm font-medium text-primary hover:underline"
    >
      {customerName ?? '—'}
    </Link>
  );
}
